import React from 'react';
import { i18n } from '@lt/localization';

import styled, { css } from 'styled-components';

type WeightLabelProps = {
  weight?: number;
  noBaggage: boolean;
  isLabelInside?: boolean;
};

const WeightLabel = ({
  weight,
  noBaggage,
  isLabelInside = false,
}: WeightLabelProps) => (
  <StyledLabel
    $weight={weight}
    $isLabelInside={isLabelInside}
    $noBaggage={noBaggage}
  >
    {noBaggage ? (
      i18n.t('checkout.flight.luggage.textNo')
    ) : (
      <>
        <span>{weight}</span>
        {!isLabelInside && (
          <>
            &nbsp;
            <span>{i18n.t('checkout.flight.luggage.weight')}</span>
          </>
        )}
      </>
    )}
  </StyledLabel>
);

const StyledLabel = styled.div<{
  $noBaggage: boolean;
  $isLabelInside: boolean;
  $weight?: number;
}>`
  color: var(--black);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;

  ${({ $noBaggage, $isLabelInside, $weight }) =>
    $isLabelInside
      ? css`
          color: var(--white);
          font-size: 8px;

          position: absolute;
          transform: ${() =>
            $weight && $weight < 10
              ? css`translate(7px, 1.5px)`
              : css`translate(5.5px, 1.5px)`};
        `
      : $noBaggage &&
        css`
          color: var(--grey2);
        `};
`;

export default WeightLabel;
